module.exports = __webpack_public_path__ + "img/melati-dots.0658b26c.png";